import type { SxProps, Theme } from '@mui/material';

export const notFoundRootSx: SxProps<Theme> = {
  alignItems: 'center',
  textAlign: 'center',
};
